var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.107 9.455 3.16-1.339a.533.533 0 0 0 .135-.08l5.317-5.33A.93.93 0 0 0 12 2.021a.93.93 0 0 0-.281-.683L10.66.281A.93.93 0 0 0 9.978 0a.93.93 0 0 0-.683.281L3.978 5.598a.376.376 0 0 0-.094.148l-1.34 3.147a.402.402 0 0 0 .094.469c.134.134.29.165.47.093zm7.098-6.602L9.147 1.795l.83-.83 1.059 1.057-.83.83zM3.951 8.049l.777-1.835 3.736-3.736 1.058 1.058-3.736 3.736-1.835.777zM11.518 12a.465.465 0 0 0 .341-.14.465.465 0 0 0 .141-.342.465.465 0 0 0-.14-.342.465.465 0 0 0-.342-.14H.482a.465.465 0 0 0-.341.14.465.465 0 0 0-.141.342c0 .134.047.248.14.341.094.094.208.141.342.141h11.036z",
    fill: "#303030",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.778becac9ba37468c7cd3f150a0673d3.svg";
export { ForwardRef as ReactComponent };